export default __webpack_public_path__ + "static/media/curtain.b5e4860b.svg";